import NfcIcon from '@mui/icons-material/Nfc';
import Box from '@mui/material/Box';
import { blue } from '@mui/material/colors';
import Typography from '@mui/material/Typography';
import React from 'react';

interface NFCScanIndicatorProps {
    translations: Record<string, string>;
}

export const NFCScanIndicator: React.FC<NFCScanIndicatorProps> = ({ translations }) => (
    <Box textAlign="center" my={4}>
        <NfcIcon
            style={{
                fontSize: '6rem',
                marginBottom: '1.5rem',
                color: blue[600],
            }}
        />

        <Typography variant="h6">{translations.MENU_LINK_SCAN_NFC}</Typography>
    </Box>
);
